import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Shield, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const navLinks = [
{ name: "Services", href: "#services" },
{ name: "Why Privacy", href: "#privacy" },
{ name: "Process", href: "#process" },
{ name: "Testimonials", href: "#testimonials" }];


export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ?
        "backdrop-blur-xl bg-[#050505]/80 border-b border-white/5" :
        "bg-transparent"}`
        }
        data-testid="navigation">

        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <a
              href="#"
              className="flex items-center gap-3 group"
              data-testid="nav-logo"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}>

              <div className="w-10 h-10 rounded-xl bg-[#5e5ce6]/20 flex items-center justify-center border border-[#5e5ce6]/30 group-hover:bg-[#5e5ce6]/30 transition-colors duration-300">
                <Shield className="w-5 h-5 text-[#5e5ce6]" />
              </div>
              <span className="text-xl font-semibold tracking-tight text-white">Fortress Integrations

              </span>
            </a>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) =>
              <button
                key={link.name}
                onClick={() => scrollToSection(link.href)}
                className="text-sm text-white/60 hover:text-white transition-colors duration-300 font-medium"
                data-testid={`nav-link-${link.name.toLowerCase()}`}>

                  {link.name}
                </button>
              )}
            </div>

            {/* CTA Button */}
            <div className="hidden md:block">
              <Button
                onClick={() => scrollToSection("#contact")}
                className="bg-white text-black hover:bg-white/90 rounded-full px-6 py-2 text-sm font-semibold shadow-[0_0_20px_rgba(255,255,255,0.15)] hover:shadow-[0_0_30px_rgba(255,255,255,0.25)] transition-shadow duration-300"
                data-testid="nav-cta-btn">

                Book Consultation
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-2 text-white/60 hover:text-white transition-colors"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              data-testid="mobile-menu-toggle">

              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen &&
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 z-40 md:hidden pt-20"
          data-testid="mobile-menu">

            <div className="mobile-nav-backdrop h-full">
              <div className="flex flex-col gap-2 p-6">
                {navLinks.map((link, index) =>
              <motion.button
                key={link.name}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                onClick={() => scrollToSection(link.href)}
                className="text-left text-lg text-white/80 hover:text-white py-4 border-b border-white/5 transition-colors"
                data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}>

                    {link.name}
                  </motion.button>
              )}
                <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: navLinks.length * 0.1 }}
                className="pt-4">

                  <Button
                  onClick={() => scrollToSection("#contact")}
                  className="w-full bg-white text-black hover:bg-white/90 rounded-full py-3 text-sm font-semibold"
                  data-testid="mobile-cta-btn">

                    Book Consultation
                  </Button>
                </motion.div>
              </div>
            </div>
          </motion.div>
        }
      </AnimatePresence>
    </>);

};